<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>验收订单号:</label>
            <lk-input clearable v-model='query.code' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker v-model='query.createTimeStart' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker v-model='query.createTimeEnd' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input clearable v-model='query.createUserName' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select v-model='query.status' class="item">
              <lk-option v-for="(item, index) in inspectionStatus" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>供应商:</label>
            <SupplierListSelect v-model='query.supplierId'/>
          </div>
          <div class="queryItem">
            <label>成本类型:</label>
            <lk-select v-model='query.payment' class="item">
              <lk-option v-for="(item, index) in paymentType" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>随货同行单:</label>
            <lk-input clearable v-model="query.travelNo" class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearchBefore">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap mb16">
          <span v-if="this.handlePermission('printInspection')">
            <lk-button class="mr8" type="primary" @click="getPrintListData" :disabled="tempPrintIds.length === 0">打印所选</lk-button>
            <lk-button class="mr8" type="primary" @click="printSetting">设置纸张</lk-button>
          </span>
          <DownloadButton @on-click="download" v-if="handlePermission('inspectionDownload')"></DownloadButton>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
    </QueryFrame>
    <lk-modal v-model="printSettingVisiable" title="设置纸张" width='550'>
      <div class="modelContent">
        <div class="params">
          <lk-form
            :label-width='75'
            label-position="right"
          >
            <lk-row :gutter='16'>
              <lk-col span='8'>
                <lk-form-item label='纸张类型:'>
                  <lk-radio-group v-model="printPaperSize">
                    <lk-radio :label="8">二等分</lk-radio>
                    <lk-radio :label="4">三等分</lk-radio>
                  </lk-radio-group>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <div style="text-align: center;">
              <img width="450" src="../../assets/paperSize.png" alt="">
            </div>
          </lk-form>
        </div>
      </div>
      <div slot="footer">
        <lk-button @click="printSettingVisiable = false">取消</lk-button>
        <lk-button @click="confirmPrintSetting" type='primary'>确定</lk-button>
      </div>
    </lk-modal>
    <section id="printArea" ref="print" class="print-area">
      <div v-for="(printInfo, outIndex) in printInfoList" :key="outIndex">
        <div
          v-for="(item, index) in printInfo.purchasePageData" :key="index"
          class="inspection-print">
          <div class="inspection-print-header">
            <div>
              <span class="bottomFontColor">入库单位：{{printInfo.purchaseReceipt.storeName}}</span><br>
              <span class="bottomFontColor"><label style="display: inline-block; width: 60px; color: #000000;">供应商：</label>{{printInfo.purchaseReceipt.supplierCode}}</span>
            </div>
            <h3 class="bottomFontColor">{{printInfo.purchaseReceipt.storeName}} 商品购进验收记录</h3>
          </div>
          <div>
            <span class="mr10">供应商名：{{printInfo.purchaseReceipt.supplierName}}</span>
            <span class="mr10">到货日期：{{printInfo.purchaseReceipt.createTime}}</span>
            <span class="mr10">验收日期：{{printInfo.purchaseInspection.createTime}}</span>
            <span class="mr10">验收单号：{{printInfo.purchaseInspection.code}}</span>
          </div>
          <table class="c-table">
            <thead>
            <tr>
              <th style="width: 16%;">商品编码/药品名称/规格/剂型</th>
              <th style="width: 5.5%;">生产企业</th>
              <th style="width: 6%;"><span>上市许可持有人</span></th>
              <th style="width: 3.5%;">产地</th>
              <th style="width: 3.5%;">单位</th>
              <th style="width: 4.5%;">数量</th>
              <th style="width: 4.5%;">进价</th>
              <th style="width: 4.5%;">金额</th>
              <th style="width: 3.5%;">税率</th>
              <th style="width: 7.5%;">税额</th>
              <th style="width: 7.5%;">不含税金额</th>
              <th style="width: 4.5%;">DTP</th>
              <th style="width: 5%;">批号</th>
              <th style="width: 6.5%;">生产日期</th>
              <th style="width: 6.5%;">有效日期</th>
              <th style="width: 6.5%;" v-text="(printInfo.purchaseInspection && printInfo.purchaseInspection.goodsType === 2) ? '注册证号/备案号' : '批准文号'"></th>
              <th style="width: 4.5%;">结论</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(printData, printIndex) in item" :key="printIndex">
              <td style="width: 15%;"><span>{{printData.purchaseMedicineDrugSerialCode}}/{{printData.medicineInfoVoApprovedDrugNames}}/{{printData.medicineInfoVoSpecifications}}/{{printData.medicineInfoVoShortDosageFormString}}</span></td>
              <td style="width: 6.5%;"><span style="max-height: 34px;">{{printData.medicineInfoVoManufacturer}}</span></td>
              <td style="width: 6%;"><span style="max-height: 34px;">{{printData.medicineInfoVoMah}}</span></td>
              <td style="width: 3.5%;"><span>{{printData.purchaseMedicineCountryOfOrigin}}</span></td>
              <td style="width: 3.5%;"><span>{{printData.purchaseMedicineDrugMinimumPackagingUnit}}</span></td>
              <td style="width: 4.5%;"><span>{{printData.purchaseInspectionInfoPassNum}}</span></td>
              <td style="width: 4.5%;"><span>{{printData.purchaseInspectionInfoPriceBeforeTax}}</span></td>
              <td style="width: 4.5%;"><span>{{printData.purchaseInspectionInfoTotalPriceBeforeTax}}</span></td>
              <td style="width: 3.5%;"><span>{{printData.purchaseInspectionInfoTaxRate}}</span></td>
              <td style="width: 7.5%;"><span>{{printData.purchaseInspectionInfoTotalTax}}</span></td>
              <td style="width: 7.5%;"><span>{{printData.purchaseInspectionInfoTotalPriceAfterTax}}</span></td>
              <td style="width: 4.5%;"><span>{{printData.purchaseMedicineIsDtpName}}</span></td>
              <td style="width: 5%;"><span>{{printData.purchaseInspectionInfoGoodsBatchNum}}</span></td>
              <td style="width: 6.5%;"><span>{{printData.purchaseReceiptInfoProductionDate}}</span></td>
              <td style="width: 6.5%;"><span>{{printData.purchaseReceiptInfoExpiryDate}}</span></td>
              <td style="width: 6.5%;"><span>{{printData.medicineInfoVoApprovalCode}}</span></td>
              <td style="width: 4.5%;"><span>{{printData.purchaseInspectionInfoResult}}</span></td>
            </tr>
            <tr>
              <td colspan="17">
                <span class="mr10">不含税合计：{{printInfo.inspectionAmountWithoutTax}}</span>
                <span class="mr10">税金合计：{{printInfo.inspectionTax}}</span>
                <span class="mr10">合计金额：{{printInfo.inspectionAmount}}</span>
                <span class="mr10">金额大写：{{printInfo.inspectionAmountChineseString}}</span>
                <span class="mr10">本页小计：{{item.inspectionInfoAmount}}</span>
              </td>
            </tr>
            </tbody>
          </table>
          <div style="margin: 5px 0 20px 0;">
            <span class="mr10">录单员：{{printInfo.purchasePlan.createUserName}}</span>
            <span class="mr10">采购员：{{printInfo.purchaseOrder.createUserName}}</span>
            <span class="mr10">收货员：{{printInfo.purchaseReceipt.createUserName}}</span>
            <span class="mr10">验收员：{{printInfo.purchaseInspection.createUserName}}</span>
            <span class="bottomFontColor">页码：第{{index + 1}}页，共{{printInfo.purchasePageData.length}}页</span>
          </div>
          <p class="page-break"></p>
        </div>
      </div>
      <div class="no-print">不打印</div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'inspection',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    SupplierListSelect,
    DownloadButton,
  },
  computed: {
    // getNormalGoodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  data() {
    return {
      query: {
        code: '',
        status: '',
        createUserName: null,
        createTimeStart: null,
        createTimeEnd: null,
        supplierId: null,
        payment: '',
        purchaseType: null,
        travelNo: null,
      },
      columns: [
        {
          type: 'selection',
          minWidth: 60,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '验收订单号', key: 'purchaseInspectionCode', minWidth: 200, fixed: 'left',
        },
        {
          title: '供应商名称', key: 'purchaseInspectionSupplierName', minWidth: 116, tooltip: true,
        },
        {
          title: '商品类型', key: 'purchaseInspectionGoodsTypeName', width: 116, tooltip: true,
        },
        {
          title: '来源', key: 'purchaseInspectionPurchaseTypeName', width: 116, tooltip: true,
        },
        {
          title: '成本类型', key: 'purchaseInspectionPaymentName', minWidth: 116, tooltip: true,
        },
        {
          title: '单据状态', key: 'purchaseInspectionStatusName', minWidth: 116, tooltip: true,
        },
        {
          title: '随货同行单', key: 'purchaseInspectionTravelNo', minWidth: 116, tooltip: true,
        },
        {
          title: '创建人', key: 'purchaseInspectionCreateUserName', minWidth: 116, tooltip: true,
        },
        {
          title: '创建时间', key: 'purchaseInspectionCreateTime', minWidth: 130, tooltip: true,
        },
        {
          title: '含税总金额', key: 'inspectionAmount', minWidth: 116, tooltip: true,
        },
        {
          title: '不含税总金额', key: 'inspectionAmountWithoutTax', minWidth: 116, tooltip: true,
        },
        {
          title: '税金', key: 'inspectionTax', minWidth: 116, tooltip: true,
        },
        {
          title: '操作',
          minWidth: 156,
          key: 'operation',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'inspectionInfo',
                    params: { purchaseInspectionId: params.row.purchaseInspectionId },
                  });
                },
              },
            }, '查看'),
            this.handlePermission('printInspection') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.getPrintData(params.row.purchaseInspectionId);
                },
              },
            }, '打印') : null,
            this.handlePermission('udiInspection') && [25, 7, 3].indexOf(this.$store.state.storeInfo.id) >= 0 && params.row.udiFlag === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'udiInspection',
                    params: { purchaseInspectionId: params.row.purchaseInspectionId },
                  });
                },
              },
            }, 'UDI管理') : null,
          ]),
        },
      ],
      tableData: [],
      location: [],
      inspectionStatus: ['审核中', '废弃', '完成'],
      paymentType: ['普通', '寄售'],
      printInfoList: [],
      tempPrintIds: [],
      printPage: {
        size: 8,
        count: 0,
      },
      printSettingVisiable: false,
      printPaperSize: 8,
    };
  },
  methods: {
    clear() {
      this.query = {
        code: '',
        status: '',
        createUserName: '',
        createTimeStart: null,
        createTimeEnd: null,
        supplierId: null,
        payment: '',
        storeIdList: [],
        goodsType: null,
        purchaseType: null,
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // if (this.params.createTimeStart) {
      //   this.params.createTimeStart = (new Date(this.params.createTimeStart)).getTime();
      // }
      // if (this.params.createTimeEnd) {
      //   this.params.createTimeEnd = (new Date(this.params.createTimeEnd)).getTime();
      // }
      purchase.inspectionList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseInspectionCreateTime = utils.formatTime(result.purchaseInspectionCreateTime, 'YYYY/MM/DD HH:mm');
            result._checked = this.tempPrintIds.includes(result.purchaseInspectionId);
            // console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    exchageData(data) {
      const temp = utils.deepClone(data);
      temp.purchasePlan = temp.purchasePlan || { createUserName: '-' };
      temp.purchaseOrder = temp.purchaseOrder || { createUserName: '-' };
      if (temp.purchaseReceipt) {
        temp.purchaseReceipt.createTime = utils.formatDate(temp.purchaseReceipt.createTime);
      } else {
        temp.purchaseReceipt = {
          storeName: '-',
          supplierCode: '-',
          supplierName: '-',
          createUserName: '-',
          createTime: '-',
        };
      }
      if (temp.purchaseInspection) {
        temp.purchaseInspection.createTime = utils.formatDate(temp.purchaseInspection.createTime);
      } else {
        temp.purchaseInspection = {
          code: '-',
          createUserName: '-',
          createTime: '-',
        };
      }

      // 组装分页数据
      temp.purchasePageData = [];
      temp.purchaseMedicineInfoVoList = temp.purchaseMedicineInfoVoList || [];
      this.printPage.count = temp.purchaseMedicineInfoVoList.length;
      if (this.printPage.count) {
        const pages = Math.ceil(this.printPage.count / this.printPage.size); // 总页数
        for (let i = 1; i <= pages; i++) {
          const currentNum = (i - 1) * this.printPage.size;
          const currentData = temp.purchaseMedicineInfoVoList.slice(currentNum, currentNum + this.printPage.size);
          const newData = [];
          newData.inspectionInfoAmount = 0;
          currentData.forEach((item) => {
            item.purchaseReceiptInfo.productionDate = utils.formatDate(item.purchaseReceiptInfo.productionDate);
            item.purchaseReceiptInfo.expiryDate = utils.formatDate(item.purchaseReceiptInfo.expiryDate);
            newData.inspectionInfoAmount += item.inspectionInfoAmount;
            const result = {};
            utils.exchangeTable(item, result);
            newData.push(result);
          });
          newData.inspectionInfoAmount = newData.inspectionInfoAmount.toFixed(2);
          temp.purchasePageData.push(newData);
        }
      }
      return temp;
    },
    getPrintData(id) {
      this.printInspectionList([id]);
    },
    handleTempSelect(selection, row) {
      if (!this.tempPrintIds.includes(row.purchaseInspectionId)) {
        this.tempPrintIds.push(row.purchaseInspectionId);
      }
    },
    handleTempCancel(selection, row) {
      for (let i = 0, len = this.tempPrintIds.length; i < len; i++) {
        if (this.tempPrintIds[i] === row.purchaseInspectionId) {
          this.tempPrintIds.splice(i, 1);
          break;
        }
      }
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        // console.log(item.purchaseInspectionId);
        if (!this.tempPrintIds.includes(item.purchaseInspectionId)) {
          this.tempPrintIds.push(item.purchaseInspectionId);
        }
      });
    },
    handleSelectAllCancel() {
      this.tableData.forEach((good) => {
        for (let i = 0, len = this.tempPrintIds.length; i < len; i++) {
          if (this.tempPrintIds[i] === good.purchaseInspectionId) {
            this.tempPrintIds.splice(i, 1);
            break;
          }
        }
      });
    },
    getPrintListData() {
      this.printInspectionList(this.tempPrintIds);
    },
    printInspectionList(printIds) {
      purchase.printInspectionList({ purchaseInspectionIdList: printIds }).then((res) => {
        if (res.data.status === 200) {
          const data = [];
          res.data.data.forEach((item) => {
            data.push(this.exchageData(item));
          });
          this.printInfoList = data;
          this.$nextTick(() => {
            this.$print(this.$refs.print);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    printSetting() {
      this.printSettingVisiable = true;
      this.printPaperSize = this.printPage.size;
    },
    confirmPrintSetting() {
      this.printPage.size = this.printPaperSize;
      this.printSettingVisiable = false;
      localStorage.printPaperSize = this.printPage.size;
      this.$Message.success('设置成功！');
    },
    handleSearchBefore() {
      this.tempPrintIds = [];
      this.handleSearch();
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      // params.createTimeStart = utils.exchangeDate(params.createTimeStart);
      // params.createTimeEnd = utils.exchangeDate(params.createTimeEnd);

      params.queryCondition = utils.getQueryCondition('.queryContainer');
      purchase.inspectionListDown(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    if (localStorage.printPaperSize) {
      this.printPage.size = Number(localStorage.printPaperSize);
    }
    this.handleSearch(true, () => {
      this.tempPrintIds = [];
    });
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店名称', key: 'purchaseInspectionStoreName', minWidth: 116, tooltip: true,
      });
    }
  },
};
</script>

<style lang="less" scoped>
  @media print {
    .print-area {
      display: block;
    }
    .page-break {
      page-break-after: always;
    }
    .inspection-print-header {
      display: flex;

      h3 {
        flex: 1 0 auto;
        text-align: center;
      }
    }
  }

  @media screen {
    .print-area {
      display: none;
    }
    .inspection-print-header {
      display: flex;

      h3 {
        flex: 1 0 auto;
        text-align: center;
      }
    }
  }
  .mr10{
    margin-right: 10px;
    color: #000000;
  }
  .bottomFontColor {
    color: #000000;
  }
  .c-table {
    width: 1004px;
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0;
    color: #000000;
    td,
    th {
      border: 1px solid;
    }
    thead {
      th{
        position: relative;
        font-size: 12px;
        padding: 0 2px;
        font-weight: normal;
        text-align: center;
        span{
          word-break: break-all;
          display: inline-block;
          overflow-y: hidden;
        }
      }
    }

    tbody {
      td {
        font-size: 12px;
        text-align: left;
        padding: 0 2px;
        span {
          word-break: break-all;
          display: inline-block;
          overflow-y: hidden;
          &.small {
            transform: scale(0.6) translateX(0);
          }
        }
      }
    }
  }
</style>
